/**
 * Bet result types shared between frontend and backend.
 * Single source of truth for bet outcome values.
 */

/** Possible outcomes for a parlay */
export const BET_STATUSES = ['pending', 'won', 'lost', 'push', 'void'] as const;
export type BetStatus = (typeof BET_STATUSES)[number];
export type SettledBetStatus = Exclude<BetStatus, 'pending'>;

/** Individual leg hit/miss result */
export type LegResult = 'hit' | 'miss' | 'push' | null;

/** Check if a value is a valid BetStatus */
export function isValidBetStatus(value: unknown): value is BetStatus {
  return typeof value === 'string' && (BET_STATUSES as readonly string[]).includes(value);
}
